/**
 * InfoBar Component
 *
 * Bar tipis di bawah header yang menampilkan informasi kontekstual penting:
 * - Tahun Buku Aktif (dengan jenis: NORMAL/LAMPAU)
 * - Nama Perusahaan (dengan popover detail)
 *
 * Informasi ini WAJIB selalu terlihat karena:
 * - Menentukan database transaksi yang diakses
 * - Semua input jurnal bergantung pada tahun buku aktif
 * - Kesalahan tahun = data masuk ke database yang salah
 */

import { CalendarOutlined, BankOutlined, DownOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { useAppStore } from '@/stores/appStore';
import { useAuthStore } from '@/modules/auth/authStore';
import { CompanyPopover } from './CompanyPopover';

export function InfoBar() {
  const { TahunBukuAktif, JenisTahunBuku, StatusBuku } = useAppStore();
  const NamaPerusahaan = useAuthStore((state) => state.NamaPerusahaan);

  // Warna tag berdasarkan jenis tahun buku
  const jenisColor = JenisTahunBuku === 'NORMAL' ? 'green' : 'orange';

  // Warna status buku
  const statusColor = StatusBuku === 'OPEN' ? 'green' : 'red';

  return (
    <div className="app-infobar">
      <div className="infobar-content">
        {/* Tahun Buku */}
        <div className="infobar-item">
          <CalendarOutlined className="infobar-icon" />
          <span className="infobar-label">Tahun Buku:</span>
          <span className="infobar-value">{TahunBukuAktif}</span>
          <Tag color={jenisColor} className="infobar-tag">
            {JenisTahunBuku}
          </Tag>
          <Tag color={statusColor} className="infobar-tag">
            {StatusBuku}
          </Tag>
        </div>

        {/* Separator */}
        <div className="infobar-separator" />

        {/* Nama Perusahaan dengan Popover */}
        <CompanyPopover>
          <div className="infobar-item infobar-clickable">
            <BankOutlined className="infobar-icon" />
            <span className="infobar-value">{NamaPerusahaan || 'Tidak ada perusahaan'}</span>
            <DownOutlined style={{ fontSize: 10, marginLeft: 4, color: 'var(--color-text-secondary)' }} />
          </div>
        </CompanyPopover>
      </div>
    </div>
  );
}
